/**
 * District-to-state mapping data derived from eCourts.
 * Generated from /tmp/district_to_state.json with manual corrections.
 *
 * - Keys are lowercase district names.
 * - Values are a single state string, or string[] for ambiguous districts.
 * - chandigarh maps to its own UT 'Chandigarh' (not Punjab).
 */

export const DISTRICT_TO_STATE: Record<string, string | string[]> = {
  'adilabad': 'Telangana',
  'agar malwa': 'Madhya Pradesh',
  'agra': 'Uttar Pradesh',
  'ahmedabad': 'Gujarat',
  'ahmednagar': 'Maharashtra',
  'aizawl': 'Mizoram',
  'ajmer': 'Rajasthan',
  'akola': 'Maharashtra',
  'alappuzha': 'Kerala',
  'aligarh': 'Uttar Pradesh',
  'alipurduar': 'West Bengal',
  'alirajpur': 'Madhya Pradesh',
  'almora': 'Uttarakhand',
  'alwar': 'Rajasthan',
  'ambala': 'Haryana',
  'ambedkar nagar': 'Uttar Pradesh',
  'amravati': 'Maharashtra',
  'amreli': 'Gujarat',
  'amritsar': 'Punjab',
  'amroha': 'Uttar Pradesh',
  'anand': 'Gujarat',
  'ananthapur': 'Andhra Pradesh',
  'anantnag': 'Jammu and Kashmir',
  'anjaw': 'Arunachal Pradesh',
  'anugul': 'Odisha',
  'anuppur': 'Madhya Pradesh',
  'araria': 'Bihar',
  'aravalli at modasa': 'Gujarat',
  'ariyalur': 'Tamil Nadu',
  'arwal': 'Bihar',
  'ashoknagr': 'Madhya Pradesh',
  'auraiya': 'Uttar Pradesh',
  'aurangabad': ['Bihar', 'Maharashtra'],
  'ayodhya': 'Uttar Pradesh',
  'azamgarh': 'Uttar Pradesh',
  'bagalkot': 'Karnataka',
  'bageshwar': 'Uttarakhand',
  'baghpat': 'Uttar Pradesh',
  'bahraich': 'Uttar Pradesh',
  'bajali': 'Assam',
  'baksa': 'Assam',
  'balaghat': 'Madhya Pradesh',
  'balangir': 'Odisha',
  'balasore': 'Odisha',
  'ballari': 'Karnataka',
  'ballia': 'Uttar Pradesh',
  'balod': 'Chhattisgarh',
  'balodabazar': 'Chhattisgarh',
  'balotra': 'Rajasthan',
  'balrampur': 'Uttar Pradesh',
  'balrampur ramanujganj': 'Chhattisgarh',
  'banaskanth at palanpur': 'Gujarat',
  'banda': 'Uttar Pradesh',
  'bandipora': 'Jammu and Kashmir',
  'banka': 'Bihar',
  'bankura': 'West Bengal',
  'banswara': 'Rajasthan',
  'barabanki': 'Uttar Pradesh',
  'baramulla': 'Jammu and Kashmir',
  'baran': 'Rajasthan',
  'bareilly': 'Uttar Pradesh',
  'bargarh': 'Odisha',
  'barmer': 'Rajasthan',
  'barnala': 'Punjab',
  'barpeta': 'Assam',
  'barwani': 'Madhya Pradesh',
  'bastar': 'Chhattisgarh',
  'basti': 'Uttar Pradesh',
  'bathinda': 'Punjab',
  'beawer': 'Rajasthan',
  'beed': 'Maharashtra',
  'begusarai': 'Bihar',
  'belagavi': 'Karnataka',
  'bemetara': 'Chhattisgarh',
  'bengaluru': 'Karnataka',
  'bengaluru rural': 'Karnataka',
  'bettiah': 'Bihar',
  'betul': 'Madhya Pradesh',
  'bhadohi sr nagar': 'Uttar Pradesh',
  'bhadradri kothagudem': 'Telangana',
  'bhadrak': 'Odisha',
  'bhagalpur': 'Bihar',
  'bhandara': 'Maharashtra',
  'bharatpur': 'Rajasthan',
  'bharuch': 'Gujarat',
  'bhavnagar': 'Gujarat',
  'bhilwara': 'Rajasthan',
  'bhind': 'Madhya Pradesh',
  'bhiwani': 'Haryana',
  'bhojpur': 'Bihar',
  'bhopal': 'Madhya Pradesh',
  'bichom': 'Arunachal Pradesh',
  'bidar': 'Karnataka',
  'bijnor': 'Uttar Pradesh',
  'bikaner': 'Rajasthan',
  'bilaspur': ['Chhattisgarh', 'Himachal Pradesh'],
  'birbhum': 'West Bengal',
  'bishnupur': 'Manipur',
  'biswanath': 'Assam',
  'bokaro': 'Jharkhand',
  'bongaigaon': 'Assam',
  'botad': 'Gujarat',
  'boudh': 'Odisha',
  'budaun': 'Uttar Pradesh',
  'budgam': 'Jammu and Kashmir',
  'bulandshahr': 'Uttar Pradesh',
  'buldhana': 'Maharashtra',
  'bundi': 'Rajasthan',
  'burhanpur': 'Madhya Pradesh',
  'buxar': 'Bihar',
  'cachar': 'Assam',
  'calcutta': 'West Bengal',
  'central': 'Delhi',
  'chamba': 'Himachal Pradesh',
  'chamoli': 'Uttarakhand',
  'champawat': 'Uttarakhand',
  'champhai': 'Mizoram',
  'chamrajnagar': 'Karnataka',
  'chandauli': 'Uttar Pradesh',
  'chandel': 'Manipur',
  'chandigarh': 'Chandigarh',
  'chandrapur': 'Maharashtra',
  'changlang': 'Arunachal Pradesh',
  'charaideo': 'Assam',
  'charkhi dadri': 'Haryana',
  'chatra': 'Jharkhand',
  'chengalpattu': 'Tamil Nadu',
  'chennai': 'Tamil Nadu',
  'chhatarpur': 'Madhya Pradesh',
  'chhindwara': 'Madhya Pradesh',
  'chhota udepur': 'Gujarat',
  'chikkaballapur': 'Karnataka',
  'chikkamagaluru': 'Karnataka',
  'chirang': 'Assam',
  'chitradurga': 'Karnataka',
  'chitrakoot': 'Uttar Pradesh',
  'chittoor': 'Andhra Pradesh',
  'chittorgarh': 'Rajasthan',
  'churachandpur': 'Manipur',
  'churu': 'Rajasthan',
  'coimbatore': 'Tamil Nadu',
  'coochbehar': 'West Bengal',
  'crime branch': 'Arunachal Pradesh',
  'cuddalore': 'Tamil Nadu',
  'cuttack': 'Odisha',
  'dahod': 'Gujarat',
  'dakshina kannada': 'Karnataka',
  'daltonganj': 'Jharkhand',
  'damoh': 'Madhya Pradesh',
  'dangs': 'Gujarat',
  'dantewada': 'Chhattisgarh',
  'darbhanga': 'Bihar',
  'darjeeling': 'West Bengal',
  'darrang': 'Assam',
  'datia': 'Madhya Pradesh',
  'dausa': 'Rajasthan',
  'davangere': 'Karnataka',
  'deeg': 'Rajasthan',
  'dehradun': 'Uttarakhand',
  'deogarh': 'Odisha',
  'deoghar': 'Jharkhand',
  'deoria': 'Uttar Pradesh',
  'devbhumi dwarka at khambhaliya': 'Gujarat',
  'dewas': 'Madhya Pradesh',
  'dhalai': 'Tripura',
  'dhamtari': 'Chhattisgarh',
  'dhanbad': 'Jharkhand',
  'dhar': 'Madhya Pradesh',
  'dharmapuri': 'Tamil Nadu',
  'dharwad': 'Karnataka',
  'dhemaji': 'Assam',
  'dhenkanal': 'Odisha',
  'dholpur': 'Rajasthan',
  'dhubri': 'Assam',
  'dhule': 'Maharashtra',
  'dibang valley': 'Arunachal Pradesh',
  'dibrugarh': 'Assam',
  'didwana kuchaman': 'Rajasthan',
  'dima hasao': 'Assam',
  'dimapur': 'Nagaland',
  'dindigul': 'Tamil Nadu',
  'dindori': 'Madhya Pradesh',
  'doda': 'Jammu and Kashmir',
  'dumka': 'Jharkhand',
  'dungarpur': 'Rajasthan',
  'durg': 'Chhattisgarh',
  'east': 'Delhi',
  'east garo hills': 'Meghalaya',
  'east godavari': 'Andhra Pradesh',
  'east jaintia hills': 'Meghalaya',
  'east kameng': 'Arunachal Pradesh',
  'east khasi hills': 'Meghalaya',
  'east siang': 'Arunachal Pradesh',
  'east singhbhum at jamshedpur': 'Jharkhand',
  'eastern west khasi hills': 'Meghalaya',
  'ernakulam': 'Kerala',
  'erode': 'Tamil Nadu',
  'etah': 'Uttar Pradesh',
  'etawah': 'Uttar Pradesh',
  'faridabad': 'Haryana',
  'faridkot': 'Punjab',
  'farrukhabad': 'Uttar Pradesh',
  'fatehabad': 'Haryana',
  'fatehgarh sahib': 'Punjab',
  'fatehpur': 'Uttar Pradesh',
  'fazilka': 'Punjab',
  'ferozepur': 'Punjab',
  'firozabad': 'Uttar Pradesh',
  'gadag': 'Karnataka',
  'gadchiroli': 'Maharashtra',
  'gajapati': 'Odisha',
  'ganderbal': 'Jammu and Kashmir',
  'gandhinagar': 'Gujarat',
  'ganganagar': 'Rajasthan',
  'gangtok': 'Sikkim',
  'ganjam': 'Odisha',
  'garhwa': 'Jharkhand',
  'gaurela pendra marwahi': 'Chhattisgarh',
  'gautam buddha nagar': 'Uttar Pradesh',
  'gaya': 'Bihar',
  'ghaziabad': 'Uttar Pradesh',
  'ghazipur': 'Uttar Pradesh',
  'gir somnath at veraval': 'Gujarat',
  'giridih': 'Jharkhand',
  'goalpara': 'Assam',
  'godda': 'Jharkhand',
  'golaghat': 'Assam',
  'gomati': 'Tripura',
  'gonda': 'Uttar Pradesh',
  'gondia': 'Maharashtra',
  'gopalganj': 'Bihar',
  'gorakhpur': 'Uttar Pradesh',
  'gumla': 'Jharkhand',
  'guna': 'Madhya Pradesh',
  'guntur': 'Andhra Pradesh',
  'gurdaspur': 'Punjab',
  'gurugram': 'Haryana',
  'gwalior': 'Madhya Pradesh',
  'gyalshing': 'Sikkim',
  'hailakandi': 'Assam',
  'hamirpur': ['Himachal Pradesh', 'Uttar Pradesh'],
  'hanumakonda': 'Telangana',
  'hanumangarh': 'Rajasthan',
  'hapur': 'Uttar Pradesh',
  'harda': 'Madhya Pradesh',
  'hardoi': 'Uttar Pradesh',
  'haridwar': 'Uttarakhand',
  'hassan': 'Karnataka',
  'hathras': 'Uttar Pradesh',
  'haveri': 'Karnataka',
  'hazaribagh': 'Jharkhand',
  'hingoli': 'Maharashtra',
  'hisar': 'Haryana',
  'hojai': 'Assam',
  'hooghly': 'West Bengal',
  'hoshangabad': 'Madhya Pradesh',
  'hoshiarpur': 'Punjab',
  'howrah': 'West Bengal',
  'hyderabad': 'Telangana',
  'idukki': 'Kerala',
  'imphal east': 'Manipur',
  'imphal west': 'Manipur',
  'indore': 'Madhya Pradesh',
  'jabalpur': 'Madhya Pradesh',
  'jagatsinghpur': 'Odisha',
  'jagitial': 'Telangana',
  'jaipur district': 'Rajasthan',
  'jaipur metro i': 'Rajasthan',
  'jaipur metro ii': 'Rajasthan',
  'jaisalmer': 'Rajasthan',
  'jajpur': 'Odisha',
  'jalandhar': 'Punjab',
  'jalaun': 'Uttar Pradesh',
  'jalgaon': 'Maharashtra',
  'jalna': 'Maharashtra',
  'jalore': 'Rajasthan',
  'jalpaiguri': 'West Bengal',
  'jammu': 'Jammu and Kashmir',
  'jamnagar': 'Gujarat',
  'jamtara': 'Jharkhand',
  'jamui': 'Bihar',
  'jangoan': 'Telangana',
  'janjgir': 'Chhattisgarh',
  'jashpur': 'Chhattisgarh',
  'jaunpur': 'Uttar Pradesh',
  'jayashankar bhupalapally': 'Telangana',
  'jehanabad': 'Bihar',
  'jhabua': 'Madhya Pradesh',
  'jhadc court': 'Meghalaya',
  'jhajjar': 'Haryana',
  'jhalawar': 'Rajasthan',
  'jhansi': 'Uttar Pradesh',
  'jhargram': 'West Bengal',
  'jharsuguda': 'Odisha',
  'jhunjhunu': 'Rajasthan',
  'jind': 'Haryana',
  'jodhpur district': 'Rajasthan',
  'jodhpur metro': 'Rajasthan',
  'jogulamba gadwal': 'Telangana',
  'jorhat': 'Assam',
  'junagadh': 'Gujarat',
  'kachchh at bhuj': 'Gujarat',
  'kadapa': 'Andhra Pradesh',
  'kaimur at bhabhua': 'Bihar',
  'kaithal': 'Haryana',
  'kalaburagi': 'Karnataka',
  'kalahandi': 'Odisha',
  'kalimpong': 'West Bengal',
  'kallakurichi': 'Tamil Nadu',
  'kamareddy': 'Telangana',
  'kamle': 'Arunachal Pradesh',
  'kamrup': 'Assam',
  'kamrup metro': 'Assam',
  'kancheepuram': 'Tamil Nadu',
  'kandhamal': 'Odisha',
  'kangra': 'Himachal Pradesh',
  'kanker': 'Chhattisgarh',
  'kannauj': 'Uttar Pradesh',
  'kanniyakumari': 'Tamil Nadu',
  'kannur': 'Kerala',
  'kanpur dehat': 'Uttar Pradesh',
  'kanpur nagar': 'Uttar Pradesh',
  'kapurthala': 'Punjab',
  'karaikal': 'Puducherry',
  'karauli': 'Rajasthan',
  'karbi anglong': 'Assam',
  'kargil': 'Ladakh',
  'karimnagar': 'Telangana',
  'karnal': 'Haryana',
  'karur': 'Tamil Nadu',
  'kasaragod': 'Kerala',
  'kasganj': 'Uttar Pradesh',
  'kathua': 'Jammu and Kashmir',
  'katihar': 'Bihar',
  'katni': 'Madhya Pradesh',
  'kaushambi': 'Uttar Pradesh',
  'kawardha': 'Chhattisgarh',
  'kendrapada': 'Odisha',
  'keonjhar': 'Odisha',
  'keyi panyor': 'Arunachal Pradesh',
  'khadc court': 'Meghalaya',
  'khagaria': 'Bihar',
  'khairtal tijara': 'Rajasthan',
  'khammam': 'Telangana',
  'khandwa': 'Madhya Pradesh',
  'kheda at nadiad': 'Gujarat',
  'khowai': 'Tripura',
  'khunti': 'Jharkhand',
  'khurda': 'Odisha',
  'kinnaur': 'Himachal Pradesh',
  'kiphire': 'Nagaland',
  'kishanganj': 'Bihar',
  'kishtwar': 'Jammu and Kashmir',
  'kodagu': 'Karnataka',
  'koderma': 'Jharkhand',
  'kohima': 'Nagaland',
  'kokrajhar': 'Assam',
  'kolar': 'Karnataka',
  'kolhapur': 'Maharashtra',
  'kollam': 'Kerala',
  'kondagaon': 'Chhattisgarh',
  'koppal': 'Karnataka',
  'koraput': 'Odisha',
  'korba': 'Chhattisgarh',
  'koriya': 'Chhattisgarh',
  'kota': 'Rajasthan',
  'kotputli behror': 'Rajasthan',
  'kottayam': 'Kerala',
  'kozhikode': 'Kerala',
  'kra daadi': 'Arunachal Pradesh',
  'krishna': 'Andhra Pradesh',
  'krishnagiri': 'Tamil Nadu',
  'kulgam': 'Jammu and Kashmir',
  'kullu': 'Himachal Pradesh',
  'kumuram bheem asifabad': 'Telangana',
  'kupwara': 'Jammu and Kashmir',
  'kurnool': 'Andhra Pradesh',
  'kurukshetra': 'Haryana',
  'kurung kumey': 'Arunachal Pradesh',
  'kushinagar': 'Uttar Pradesh',
  'lahaul and spiti': 'Himachal Pradesh',
  'lakhimpur': 'Assam',
  'lakhimpur kheri': 'Uttar Pradesh',
  'lakhisarai': 'Bihar',
  'lakshadweep': 'Lakshadweep',
  'lalitpur': 'Uttar Pradesh',
  'latehar': 'Jharkhand',
  'latur': 'Maharashtra',
  'leh': 'Ladakh',
  'leparada': 'Arunachal Pradesh',
  'lohardaga': 'Jharkhand',
  'lohit': 'Arunachal Pradesh',
  'longding': 'Arunachal Pradesh',
  'longleng': 'Nagaland',
  'lower dibang valley': 'Arunachal Pradesh',
  'lower siang': 'Arunachal Pradesh',
  'lower subansiri': 'Arunachal Pradesh',
  'lucknow': 'Uttar Pradesh',
  'ludhiana': 'Punjab',
  'lunglei': 'Mizoram',
  'madhepura': 'Bihar',
  'madhubani': 'Bihar',
  'madurai': 'Tamil Nadu',
  'mah state cooperative appellat': 'Maharashtra',
  'mahabubabad': 'Telangana',
  'mahabubnagar': 'Telangana',
  'maharajganj': 'Uttar Pradesh',
  'maharashtra family courts': 'Maharashtra',
  'maharashtra industrial and lab': 'Maharashtra',
  'maharashtra school tribunals': 'Maharashtra',
  'mahasamund': 'Chhattisgarh',
  'mahe': 'Puducherry',
  'mahesana': 'Gujarat',
  'mahisagar at lunawada': 'Gujarat',
  'mahoba': 'Uttar Pradesh',
  'mainpuri': 'Uttar Pradesh',
  'majuli': 'Assam',
  'malappuram': 'Kerala',
  'malda': 'West Bengal',
  'malkangiri': 'Odisha',
  'mancherial': 'Telangana',
  'mandi': 'Himachal Pradesh',
  'mandla': 'Madhya Pradesh',
  'mandleshwar': 'Madhya Pradesh',
  'mandsaur': 'Madhya Pradesh',
  'mandya': 'Karnataka',
  'mangan': 'Sikkim',
  'mansa': 'Punjab',
  'mathura': 'Uttar Pradesh',
  'mau': 'Uttar Pradesh',
  'mayiladuthurai': 'Tamil Nadu',
  'mayurbhanj': 'Odisha',
  'medak': 'Telangana',
  'medchal malkajgiri': 'Telangana',
  'meerut': 'Uttar Pradesh',
  'merta nagaur': 'Rajasthan',
  'mirzapur': 'Uttar Pradesh',
  'moga': 'Punjab',
  'mokokchung': 'Nagaland',
  'mon': 'Nagaland',
  'moradabad': 'Uttar Pradesh',
  'morbi': 'Gujarat',
  'morena': 'Madhya Pradesh',
  'morigaon': 'Assam',
  'motihari': 'Bihar',
  'mulugu': 'Telangana',
  'mumbai (suburban)': 'Maharashtra',
  'mumbai city civil court': 'Maharashtra',
  'mumbai cmm courts': 'Maharashtra',
  'mumbai motor accident claims t': 'Maharashtra',
  'mumbai small causes court': 'Maharashtra',
  'mungeli': 'Chhattisgarh',
  'munger': 'Bihar',
  'murshidabad': 'West Bengal',
  'muzaffarnagar': 'Uttar Pradesh',
  'muzaffarpur': 'Bihar',
  'mysuru': 'Karnataka',
  'nabarangpur': 'Odisha',
  'nadia': 'West Bengal',
  'nagaon': 'Assam',
  'nagapattinam': 'Tamil Nadu',
  'nagarkurnool': 'Telangana',
  'nagpur': 'Maharashtra',
  'nainital': 'Uttarakhand',
  'nalanda': 'Bihar',
  'nalbari': 'Assam',
  'nalgonda': 'Telangana',
  'namakkal': 'Tamil Nadu',
  'namchi': 'Sikkim',
  'namsai': 'Arunachal Pradesh',
  'nanded': 'Maharashtra',
  'nandurbar': 'Maharashtra',
  'narayanpet': 'Telangana',
  'narmada': 'Gujarat',
  'narnaul': 'Haryana',
  'narsinghpur': 'Madhya Pradesh',
  'nashik': 'Maharashtra',
  'navsari': 'Gujarat',
  'nawada': 'Bihar',
  'nayagarh': 'Odisha',
  'neemuch': 'Madhya Pradesh',
  'nellore': 'Andhra Pradesh',
  'new delhi': 'Delhi',
  'nicobars': 'Andaman and Nicobar',
  'nirmal': 'Telangana',
  'nizamabad': 'Telangana',
  'north': 'Delhi',
  'north  twenty four parganas': 'West Bengal',
  'north and middle andaman': 'Andaman and Nicobar',
  'north dinajpur': 'West Bengal',
  'north east': 'Delhi',
  'north garo hills': 'Meghalaya',
  'north goa': 'Goa',
  'north tripura': 'Tripura',
  'north west': 'Delhi',
  'nuapada': 'Odisha',
  'nuh': 'Haryana',
  'osmanabad': 'Maharashtra',
  'pakke kessang': 'Arunachal Pradesh',
  'pakur': 'Jharkhand',
  'pakyong': 'Sikkim',
  'palakkad': 'Kerala',
  'palghar': 'Maharashtra',
  'pali': 'Rajasthan',
  'palwal': 'Haryana',
  'panchkula': 'Haryana',
  'panchmahal at godhra': 'Gujarat',
  'panipat': 'Haryana',
  'panna': 'Madhya Pradesh',
  'papum pare': 'Arunachal Pradesh',
  'parbhani': 'Maharashtra',
  'paschim bardhaman': 'West Bengal',
  'paschim medinpur': 'West Bengal',
  'patan': 'Gujarat',
  'pathanamthitta': 'Kerala',
  'pathankot': 'Punjab',
  'patiala': 'Punjab',
  'patna': 'Bihar',
  'pauri garhwal': 'Uttarakhand',
  'peddapalli': 'Telangana',
  'perambalur': 'Tamil Nadu',
  'peren': 'Nagaland',
  'phalodi': 'Rajasthan',
  'phek': 'Nagaland',
  'pilibhit': 'Uttar Pradesh',
  'pithoragarh': 'Uttarakhand',
  'poonch': 'Jammu and Kashmir',
  'porbandar': 'Gujarat',
  'port blair': 'Andaman and Nicobar',
  'prakasham': 'Andhra Pradesh',
  'pratapgarh': ['Rajasthan', 'Uttar Pradesh'],
  'prayagraj': 'Uttar Pradesh',
  'puducherry': 'Puducherry',
  'pudukkottai': 'Tamil Nadu',
  'pulwama': 'Jammu and Kashmir',
  'pune': 'Maharashtra',
  'purba bardhaman': 'West Bengal',
  'purba medinipur': 'West Bengal',
  'puri': 'Odisha',
  'purnea': 'Bihar',
  'purulia': 'West Bengal',
  'raebareli': 'Uttar Pradesh',
  'raichur': 'Karnataka',
  'raigad': 'Maharashtra',
  'raigarh': 'Chhattisgarh',
  'raipur': 'Chhattisgarh',
  'raisen': 'Madhya Pradesh',
  'rajanna siricilla': 'Telangana',
  'rajgarh': 'Madhya Pradesh',
  'rajkot': 'Gujarat',
  'rajnandgaon': 'Chhattisgarh',
  'rajouri': 'Jammu and Kashmir',
  'rajsamand': 'Rajasthan',
  'ramanagara': 'Karnataka',
  'ramanathapuram': 'Tamil Nadu',
  'ramban': 'Jammu and Kashmir',
  'ramgarh': 'Jharkhand',
  'rampur': 'Uttar Pradesh',
  'ranchi': 'Jharkhand',
  'rangareddy': 'Telangana',
  'ranipet': 'Tamil Nadu',
  'ratlam': 'Madhya Pradesh',
  'ratnagiri': 'Maharashtra',
  'rayagada': 'Odisha',
  'reasi': 'Jammu and Kashmir',
  'rewa': 'Madhya Pradesh',
  'rewari': 'Haryana',
  'ri bhoi': 'Meghalaya',
  'rohtak': 'Haryana',
  'rohtas sasaram': 'Bihar',
  'rudraprayag': 'Uttarakhand',
  'rupnagar': 'Punjab',
  'sabarkantha at himmatnagar': 'Gujarat',
  'sagar': 'Madhya Pradesh',
  'saharanpur': 'Uttar Pradesh',
  'saharsa': 'Bihar',
  'sahibganj': 'Jharkhand',
  'salem': 'Tamil Nadu',
  'salumber': 'Rajasthan',
  'samastipur': 'Bihar',
  'samba': 'Jammu and Kashmir',
  'sambalpur': 'Odisha',
  'sambhal at chandausi': 'Uttar Pradesh',
  'sangareddy': 'Telangana',
  'sangli': 'Maharashtra',
  'sangrur': 'Punjab',
  'santkabir nagar': 'Uttar Pradesh',
  'saran at chapra': 'Bihar',
  'sas nagar': 'Punjab',
  'satara': 'Maharashtra',
  'satna': 'Madhya Pradesh',
  'sawai madhopur': 'Rajasthan',
  'sbs nagar': 'Punjab',
  'sehore': 'Madhya Pradesh',
  'senapati': 'Manipur',
  'seoni': 'Madhya Pradesh',
  'sepahijala': 'Tripura',
  'seraikella': 'Jharkhand',
  'shahdara': 'Delhi',
  'shahdol': 'Madhya Pradesh',
  'shahjahanpur': 'Uttar Pradesh',
  'shajapur': 'Madhya Pradesh',
  'shamli at kairana': 'Uttar Pradesh',
  'sheikhpura': 'Bihar',
  'sheohar': 'Bihar',
  'sheopur': 'Madhya Pradesh',
  'shi yomi': 'Arunachal Pradesh',
  'shimla': 'Himachal Pradesh',
  'shivamogga': 'Karnataka',
  'shivpuri': 'Madhya Pradesh',
  'shopian': 'Jammu and Kashmir',
  'shravasti': 'Uttar Pradesh',
  'siang': 'Arunachal Pradesh',
  'siddharthnagar': 'Uttar Pradesh',
  'siddipet': 'Telangana',
  'sidhi': 'Madhya Pradesh',
  'sikar': 'Rajasthan',
  'simdega': 'Jharkhand',
  'sindhudurg': 'Maharashtra',
  'singrauli': 'Madhya Pradesh',
  'sirmaur': 'Himachal Pradesh',
  'sirohi': 'Rajasthan',
  'sirsa': 'Haryana',
  'sitamarhi': 'Bihar',
  'sitapur': 'Uttar Pradesh',
  'sivagangai': 'Tamil Nadu',
  'sivasagar': 'Assam',
  'siwan': 'Bihar',
  'solan': 'Himachal Pradesh',
  'solapur': 'Maharashtra',
  'sonbhadra': 'Uttar Pradesh',
  'sonepat': 'Haryana',
  'sonepur': 'Odisha',
  'sonitpur': 'Assam',
  'soreng': 'Sikkim',
  'south': 'Delhi',
  'south andamans': 'Andaman and Nicobar',
  'south dinajpur': 'West Bengal',
  'south east': 'Delhi',
  'south garo hills': 'Meghalaya',
  'south goa': 'Goa',
  'south salmara': 'Assam',
  'south tripura': 'Tripura',
  'south twenty four parganas': 'West Bengal',
  'south west': 'Delhi',
  'south west garo hills': 'Meghalaya',
  'south west khasi hills': 'Meghalaya',
  'sri muktsar sahib': 'Punjab',
  'sribhumi': 'Assam',
  'srikakulam': 'Andhra Pradesh',
  'srinagar': 'Jammu and Kashmir',
  'sukma': 'Chhattisgarh',
  'sultanpur': 'Uttar Pradesh',
  'sundargarh': 'Odisha',
  'supaul': 'Bihar',
  'surajpur': 'Chhattisgarh',
  'surat': 'Gujarat',
  'surendranagar': 'Gujarat',
  'surguja at ambikapur': 'Chhattisgarh',
  'suryapet': 'Telangana',
  'tamenglong': 'Manipur',
  'tapi': 'Gujarat',
  'tarn taran': 'Punjab',
  'tawang': 'Arunachal Pradesh',
  'tehri garhwal': 'Uttarakhand',
  'tenkasi': 'Tamil Nadu',
  'thane': 'Maharashtra',
  'thanjavur': 'Tamil Nadu',
  'the nilgiris': 'Tamil Nadu',
  'theni': 'Tamil Nadu',
  'thiruvananthapuram': 'Kerala',
  'thoothukudi': 'Tamil Nadu',
  'thoubal': 'Manipur',
  'thrissur': 'Kerala',
  'tikamgarh': 'Madhya Pradesh',
  'tinsukia': 'Assam',
  'tirap': 'Arunachal Pradesh',
  'tiruchirappalli': 'Tamil Nadu',
  'tirunelveli': 'Tamil Nadu',
  'tirupathur': 'Tamil Nadu',
  'tiruppur': 'Tamil Nadu',
  'tiruvallur': 'Tamil Nadu',
  'tiruvannamalai': 'Tamil Nadu',
  'tiruvarur': 'Tamil Nadu',
  'tonk': 'Rajasthan',
  'tuensang': 'Nagaland',
  'tumakuru': 'Karnataka',
  'udaipur': 'Rajasthan',
  'udalguri': 'Assam',
  'udham singh nagar': 'Uttarakhand',
  'udhampur': 'Jammu and Kashmir',
  'udupi': 'Karnataka',
  'ujjain': 'Madhya Pradesh',
  'ukhrul': 'Manipur',
  'umaria': 'Madhya Pradesh',
  'una': 'Himachal Pradesh',
  'unakoti': 'Tripura',
  'unnao': 'Uttar Pradesh',
  'upper siang': 'Arunachal Pradesh',
  'upper subansiri': 'Arunachal Pradesh',
  'uttara kannada': 'Karnataka',
  'uttarkashi': 'Uttarakhand',
  'vadodara': 'Gujarat',
  'vaishali': 'Bihar',
  'valsad': 'Gujarat',
  'varanasi': 'Uttar Pradesh',
  'vellore': 'Tamil Nadu',
  'vidisha': 'Madhya Pradesh',
  'vijayanagar': 'Karnataka',
  'vijayapura': 'Karnataka',
  'vikarabad': 'Telangana',
  'viluppuram': 'Tamil Nadu',
  'virudhunagar': 'Tamil Nadu',
  'visakapatnam': 'Andhra Pradesh',
  'vizianagaram': 'Andhra Pradesh',
  'wanaparthy': 'Telangana',
  'warangal': 'Telangana',
  'wardha': 'Maharashtra',
  'washim': 'Maharashtra',
  'wayanad': 'Kerala',
  'west': 'Delhi',
  'west garo hills': 'Meghalaya',
  'west godavari': 'Andhra Pradesh',
  'west jaintia hills': 'Meghalaya',
  'west kameng': 'Arunachal Pradesh',
  'west karbi anglong': 'Assam',
  'west khasi hills': 'Meghalaya',
  'west siang': 'Arunachal Pradesh',
  'west singhbhum at chaibasa': 'Jharkhand',
  'west tripura': 'Tripura',
  'wokha': 'Nagaland',
  'yadadri bhuvanagiri': 'Telangana',
  'yadgir': 'Karnataka',
  'yamunanagar': 'Haryana',
  'yanam': 'Puducherry',
  'yavatmal': 'Maharashtra',
  'zunheboto': 'Nagaland',
};

/**
 * Common alternate / old names that map to official eCourts district names.
 */
export const DISTRICT_ALIASES: Record<string, { district: string; state: string }> = {
  'mumbai': { district: 'Mumbai City Civil Court', state: 'Maharashtra' },
  'bombay': { district: 'Mumbai City Civil Court', state: 'Maharashtra' },
  'bangalore': { district: 'Bengaluru', state: 'Karnataka' },
  'kanpur': { district: 'Kanpur Nagar', state: 'Uttar Pradesh' },
  'allahabad': { district: 'Prayagraj', state: 'Uttar Pradesh' },
  'prayagraj': { district: 'Prayagraj', state: 'Uttar Pradesh' },
  'baroda': { district: 'Vadodara', state: 'Gujarat' },
  'gurgaon': { district: 'Gurugram', state: 'Haryana' },
  'noida': { district: 'Gautam Buddha Nagar', state: 'Uttar Pradesh' },
  'greater noida': { district: 'Gautam Buddha Nagar', state: 'Uttar Pradesh' },
  'madras': { district: 'Chennai', state: 'Tamil Nadu' },
  'trivandrum': { district: 'Thiruvananthapuram', state: 'Kerala' },
  'cochin': { district: 'Ernakulam', state: 'Kerala' },
  'kochi': { district: 'Ernakulam', state: 'Kerala' },
  'mysore': { district: 'Mysuru', state: 'Karnataka' },
  'belgaum': { district: 'Belagavi', state: 'Karnataka' },
  'mangalore': { district: 'Dakshina Kannada', state: 'Karnataka' },
  'mangaluru': { district: 'Dakshina Kannada', state: 'Karnataka' },
  'vizag': { district: 'Visakapatnam', state: 'Andhra Pradesh' },
  'vishakhapatnam': { district: 'Visakapatnam', state: 'Andhra Pradesh' },
  'visakhapatnam': { district: 'Visakapatnam', state: 'Andhra Pradesh' },
  'pondicherry': { district: 'Puducherry', state: 'Puducherry' },
  'poona': { district: 'Pune', state: 'Maharashtra' },
  'benares': { district: 'Varanasi', state: 'Uttar Pradesh' },
  'kashi': { district: 'Varanasi', state: 'Uttar Pradesh' },
  'gulbarga': { district: 'Kalaburagi', state: 'Karnataka' },
  'shimoga': { district: 'Shivamogga', state: 'Karnataka' },
  'hubli': { district: 'Dharwad', state: 'Karnataka' },
  'hubballi': { district: 'Dharwad', state: 'Karnataka' },
  'kolkata': { district: 'Calcutta', state: 'West Bengal' },
  'calicut': { district: 'Kozhikode', state: 'Kerala' },
  'ooty': { district: 'The Nilgiris', state: 'Tamil Nadu' },
  'ootacamund': { district: 'The Nilgiris', state: 'Tamil Nadu' },
  'banaras': { district: 'Varanasi', state: 'Uttar Pradesh' },
  'jamshedpur': { district: 'East Singhbhum At Jamshedpur', state: 'Jharkhand' },
  'jaipur': { district: 'Jaipur District', state: 'Rajasthan' },
  'jodhpur': { district: 'Jodhpur District', state: 'Rajasthan' },
  'delhi': { district: 'New Delhi', state: 'Delhi' },
  // Additional aliases from eCourts database
  'bellary': { district: 'Ballari', state: 'Karnataka' },
  'chikmagalur': { district: 'Chikkamagaluru', state: 'Karnataka' },
  'tumkur': { district: 'Tumakuru', state: 'Karnataka' },
  'simla': { district: 'Shimla', state: 'Himachal Pradesh' },
  'nasik': { district: 'Nashik', state: 'Maharashtra' },
  'tanjore': { district: 'Thanjavur', state: 'Tamil Nadu' },
  'trichy': { district: 'Tiruchirappalli', state: 'Tamil Nadu' },
  'tuticorin': { district: 'Thoothukudi', state: 'Tamil Nadu' },
  'alleppey': { district: 'Alappuzha', state: 'Kerala' },
  'cannanore': { district: 'Kannur', state: 'Kerala' },
  'quilon': { district: 'Kollam', state: 'Kerala' },
  'palghat': { district: 'Palakkad', state: 'Kerala' },
  'trichur': { district: 'Thrissur', state: 'Kerala' },
  'faizabad': { district: 'Ayodhya', state: 'Uttar Pradesh' },
  'purnia': { district: 'Purnea', state: 'Bihar' },
  'sasaram': { district: 'Rohtas', state: 'Bihar' },
  'chapra': { district: 'Saran', state: 'Bihar' },
  'bhuj': { district: 'Kutch', state: 'Gujarat' },
  'godhra': { district: 'Panchmahal', state: 'Gujarat' },
  'navi mumbai': { district: 'Thane', state: 'Maharashtra' },
  'sambhajinagar': { district: 'Aurangabad', state: 'Maharashtra' },
  'dharashiv': { district: 'Osmanabad', state: 'Maharashtra' },
  // Ahmednagar was officially renamed Ahilyanagar in 2024; eCourts still
  // lists the district under its old name.
  'ahilyanagar': { district: 'Ahmednagar', state: 'Maharashtra' },
  'ahilya nagar': { district: 'Ahmednagar', state: 'Maharashtra' },
  'bhatinda': { district: 'Bathinda', state: 'Punjab' },
  'ferozepur': { district: 'Firozpur', state: 'Punjab' },
  'jullundur': { district: 'Jalandhar', state: 'Punjab' },
  'mohali': { district: 'SAS Nagar', state: 'Punjab' },
  'guwahati': { district: 'Kamrup Metropolitan', state: 'Assam' },
  'silchar': { district: 'Cachar', state: 'Assam' },
  'tezpur': { district: 'Sonitpur', state: 'Assam' },
  'siliguri': { district: 'Darjeeling', state: 'West Bengal' },
  'burdwan': { district: 'East Bardhaman', state: 'West Bengal' },
  'asansol': { district: 'West Bardhaman', state: 'West Bengal' },
  'rourkela': { district: 'Sundargarh', state: 'Odisha' },
  'bhubaneswar': { district: 'Khordha', state: 'Odisha' },
  'secunderabad': { district: 'Hyderabad', state: 'Telangana' },
  'narmadapuram': { district: 'Hoshangabad', state: 'Madhya Pradesh' },
  'coorg': { district: 'Kodagu', state: 'Karnataka' },
  'nowgong': { district: 'Nagaon', state: 'Assam' },
  'cuddapah': { district: 'Kadapa', state: 'Andhra Pradesh' },
  'kakinada': { district: 'East Godavari', state: 'Andhra Pradesh' },
  'vijayawada': { district: 'Krishna', state: 'Andhra Pradesh' },
  'ongole': { district: 'Prakasam', state: 'Andhra Pradesh' },
  'eluru': { district: 'West Godavari', state: 'Andhra Pradesh' },
  'bhilai': { district: 'Durg', state: 'Chhattisgarh' },
  'rudrapur': { district: 'Udham Singh Nagar', state: 'Uttarakhand' },
  'haldwani': { district: 'Nainital', state: 'Uttarakhand' },
  'rishikesh': { district: 'Dehradun', state: 'Uttarakhand' },
  // Small states / UTs where the state name doesn't match any district
  'goa': { district: 'North Goa', state: 'Goa' },
  'panaji': { district: 'North Goa', state: 'Goa' },
  'mapusa': { district: 'North Goa', state: 'Goa' },
  'margao': { district: 'South Goa', state: 'Goa' },
  'vasco': { district: 'South Goa', state: 'Goa' },
  'sikkim': { district: 'East Sikkim', state: 'Sikkim' },
  'gangtok': { district: 'East Sikkim', state: 'Sikkim' },
  'manipur': { district: 'Imphal West', state: 'Manipur' },
  'imphal': { district: 'Imphal West', state: 'Manipur' },
  'meghalaya': { district: 'East Khasi Hills', state: 'Meghalaya' },
  'shillong': { district: 'East Khasi Hills', state: 'Meghalaya' },
  'mizoram': { district: 'Aizawl', state: 'Mizoram' },
  'aizawl': { district: 'Aizawl', state: 'Mizoram' },
  'nagaland': { district: 'Kohima', state: 'Nagaland' },
  'kohima': { district: 'Kohima', state: 'Nagaland' },
  'dimapur': { district: 'Dimapur', state: 'Nagaland' },
  'tripura': { district: 'West Tripura', state: 'Tripura' },
  'agartala': { district: 'West Tripura', state: 'Tripura' },
  'arunachal pradesh': { district: 'Papum Pare', state: 'Arunachal Pradesh' },
  'itanagar': { district: 'Papum Pare', state: 'Arunachal Pradesh' },
  'ladakh': { district: 'Leh', state: 'Ladakh' },
  'leh': { district: 'Leh', state: 'Ladakh' },
  // eCourts Gujarat has a single "Ahmedabad" district; the Ahmedabad (Rural)
  // judiciary and its taluka courts (Dhandhuka, Dholka, Sanand, Viramgam…)
  // are court complexes inside it.
  'ahmedabad rural': { district: 'Ahmedabad', state: 'Gujarat' },
  'ahmedabad city': { district: 'Ahmedabad', state: 'Gujarat' },
  // Karnataka DOES split these into two eCourts districts.
  'bangalore rural': { district: 'Bengaluru Rural', state: 'Karnataka' },
};

/**
 * Districts that exist in multiple states. The router must ask the user
 * to disambiguate or use additional context (e.g. state hint).
 */
export const AMBIGUOUS_DISTRICTS = new Set(['aurangabad', 'bilaspur', 'hamirpur', 'pratapgarh']);

/**
 * District names too generic for regex substring matching in the parser.
 * They stay in DISTRICT_TO_STATE for the router fallback but are excluded
 * from the regex-tier LOCATIONS map built by buildLocationsMap().
 */
export const EXCLUDED_FROM_REGEX = new Set([
  // Delhi sub-districts — too generic
  'central', 'east', 'north', 'south', 'west',
  'north east', 'north west', 'south east', 'south west', 'shahdara',
  // Short generic names that could match inside party names
  'mon', 'una', 'mau', 'nuh', 'leh', 'dhar', 'pali', 'puri',
  // Special Maharashtra court entries (not real districts)
  'maharashtra family courts', 'maharashtra industrial and lab',
  'maharashtra school tribunals', 'mah state cooperative appellat',
  'mumbai city civil court', 'mumbai cmm courts',
  'mumbai motor accident claims t', 'mumbai small causes court',
  'crime branch',
  // Meghalaya special courts
  'jhadc court', 'khadc court',
]);

/**
 * Resolve a district name to its state(s).
 * Checks aliases first, then the main DISTRICT_TO_STATE map.
 */
export function resolveDistrictState(name: string): { district: string; state: string } | { district: string; states: string[] } | null {
  const lower = name.toLowerCase().trim();

  // Check aliases first
  const alias = DISTRICT_ALIASES[lower];
  if (alias) return alias;

  // Check main map
  const state = DISTRICT_TO_STATE[lower];
  if (!state) return null;

  if (Array.isArray(state)) {
    return { district: name, states: state };
  }

  return { district: name, state };
}

/**
 * Build a LOCATIONS map for parser.ts from the district data,
 * excluding generic names that would cause false-positive regex matches.
 */
export function buildLocationsMap(): Record<string, { district: string; state: string }> {
  const locations: Record<string, { district: string; state: string }> = {};

  // Add aliases first (these override main map entries)
  for (const [key, value] of Object.entries(DISTRICT_ALIASES)) {
    if (!EXCLUDED_FROM_REGEX.has(key)) {
      locations[key] = value;
    }
  }

  // Add unique (non-ambiguous) districts from main map
  for (const [key, value] of Object.entries(DISTRICT_TO_STATE)) {
    if (EXCLUDED_FROM_REGEX.has(key)) continue;
    if (Array.isArray(value)) continue; // Skip ambiguous
    if (locations[key]) continue; // Alias already set
    // Use Title Case for district name
    const titleCase = key.split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
    locations[key] = { district: titleCase, state: value };
  }

  return locations;
}
